// src/components/SideTab/SideTab.js
import React, { useState, useEffect, useRef} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {useThemes } from '../../hooks/hooks-mongoDB/useThemes';
import {useArticles} from '../../hooks/hooks-mongoDB/useArticles';
import arrowLeft from '../../../components/images/icons/ArrowBackEssOH20.png';
import './sidetab.scss';

const SideTab = ({sizeDiv}) => {
    let Navigate = useNavigate();
    const sideTabRef = useRef(null);
    const handlerPreviewPage = () => {
        Navigate(-1);
    }
    const {themes} = useThemes();
    const [isOpen, setIsOpen] = useState(false);
    const [scrollY, setScrollY] = useState(0);
    const [isVisible, setIsVisible] = useState(true);
    const [topDiv, setTopDiv] = useState()
    // Componente 1 - Carica articles di abruzzowines
    const { articles: articles_One } = useArticles('abruzzowines');
    const arts_abruzzowines = articles_One || [];
    const temaAB = arts_abruzzowines.map(tema => ({
        articolo_titolo: tema?.articolo_titolo || '',
        collegamento: tema?.collegamento || '#'
    }));
    let nuovoABElemento = {
        articolo_titolo: "Abruzzo, terre di vino",
        collegamento: "/ilmondodeiviniabruzzese"
    };
    const artAB = [nuovoABElemento, ...temaAB];
    // Componente 2 - Carica articles di choosewines
    const { articles: articles_Two } = useArticles('choosewines');
    const arts_choosewines = articles_Two || [];
    const temaChoose = arts_choosewines.map(tema => ({
        articolo_titolo: tema?.articolo_titolo || '',
        collegamento: tema?.collegamento || '#'
    }));
    let nuovoCHElemento = {
        articolo_titolo: "Scelta del vino",
        collegamento: "/sceglierebeneivini"
    };
    const artChoose = [nuovoCHElemento, ...temaChoose];
    // Componente 3 - Carica articles di tastewines
    const { articles: articles_Tree } = useArticles('tastewines');
    const arts_tastewines = articles_Tree || [];
    const temaTaste = arts_tastewines.map(tema => ({
        articolo_titolo: tema?.articolo_titolo || '',
        collegamento: tema?.collegamento || '#'
    }));
    let nuovoTTElemento = {
        articolo_titolo: "Degustazione",
        collegamento: "/degustazionedeivini"
    };
    const artTaste = [nuovoTTElemento, ...temaTaste];
    // Componente 3 - Carica articles di province
    const abruzzo_Theme = themes[3] ? (themes[3].accordion || []) : []; // Prende direttamente l'elemento all'indice Abruzzo
    const aquila_Theme = themes[4]? (themes[4].accordion || []) : []; // Prende direttamente l'elemento all'indice Aquila
    const chieti_Theme = themes[5]? (themes[5].accordion || []) : []; // Prende direttamente l'elemento all'indice chieti
    const pescara_Theme = themes[6]? (themes[6].accordion || []) : []; // Prende direttamente l'elemento all'indice pescara 
    const teramo_Theme = themes[7]? (themes[7].accordion || []) : []; // Prende direttamente l'elemento all'indice teramo
    //Forma un solo quadro con i valori dell'accordion del tema Province
    const nav_province = [abruzzo_Theme, aquila_Theme, chieti_Theme, pescara_Theme, teramo_Theme]
    .filter(accordionArray => Array.isArray(accordionArray) && accordionArray.length > 0)
    .map(accordionArray => accordionArray[0]);  // Prende solo il primo oggetto 
    //Reduduce il quadro (array) con le tre dati necessari
    const provinceData = nav_province.map(provincia => ({
        name: provincia?.sotto_titolo || '',
        id_accord: provincia?.id_accord || 0,
        collegamento: "/provincedellabruzzo" + provincia?.name?.toLowerCase() || '#'
    })); 
    // Componente 1 - Carica articles di tipologia
    const { articles: articles_five } = useArticles('tipologia');
    const arts_Tipologia = articles_five || [];
    const temaTipo = arts_Tipologia.map(tema => ({
        articolo_titolo: tema?.articolo_titolo || '',
        collegamento: tema?.collegamento || '#'
    }));
    let nuovoTPElemento = {
        articolo_titolo: "Tipologia",
        collegamento: "/tipologiainabruzzo"
    };
    const artTipo = [nuovoTPElemento, ...temaTipo]; 
    // Componente 2 - Carica articles di vitigno
    const { articles: articles_six } = useArticles('vitigno');
    const arts_vitigni = articles_six || [];
    const temaViti = arts_vitigni.map(tema => ({
        articolo_titolo: tema?.articolo_titolo || '',
        collegamento: tema?.collegamento || '#'
    }));
    let nuovoVTElemento = {
        articolo_titolo: "Vitigni",
        collegamento: "/vitignoinabruzzo"
    };
    const artViti = [nuovoVTElemento, ...temaViti]; 

    /*
    * Function for .........
    * Novembber 09st, 2022
    */
    const toggleTab = () => {
        setIsOpen(!isOpen);
    };
    
    /*
    * Function for .........
    * Novembber 09st, 2022
    */
    // Calculer l'opacité pour l'élément fixed
    const calculateOpacity = () => {
        if (scrollY < 372) {
            const opacity = 0;
            return opacity;
        }
        return 1;
    };

    /*
    * useEffect for .........
    * Novembber 09st, 2022
    */
    useEffect(()=> {
        if(sizeDiv !== undefined) {
            setTopDiv(Math.round(sizeDiv));
        }
    }, [ sizeDiv, topDiv])

    /*
    * useEffect for .........
    * Novembber 09st, 2022
    */
    useEffect(() => {
        const handleScroll = () => {
            const position = window.scrollY;
            setScrollY(position);
            // Calculer l'opacité en fonction du scroll
            let upPosition = (position)
            let opacity = 1;
            if (upPosition > topDiv / 2) {
                opacity = 1 - (upPosition - topDiv / 2) / (topDiv / 2);
                opacity = Math.max(0, Math.min(1, opacity));
            }
            // Mettre à jour la visibilité
            setIsVisible(opacity > 0.1);
        };
            window.addEventListener('scroll', handleScroll, { passive: true });
        
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [topDiv]);

    /*
    * useEffect for .........
    * Novembber 09st, 2022
    */
    // Fermer l'onglet si on clique en dehors
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (sideTabRef.current && 
                !sideTabRef.current.contains(event.target) &&
                !event.target.closest('.tab-button')) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="fixed-element" style={{opacity: calculateOpacity(), display: isVisible ? 'block' : 'none'}}>
            <div ref={sideTabRef} className={`side-tab-container ${isOpen ? 'open' : ''}`}>
                <button className="tab-button" onClick={toggleTab} aria-label={isOpen ? 'chuidere la navigazione rapida' : 'Aprire la navigazione rapida'}>
                    <p>{isOpen ? 'Clicca per chuidere' : 'Clicca per Aprire'}</p>
                </button>    
                <div className="tab-content">
                    <h3>Navigazione veloce</h3>
                    <div className="content-moveback" onClick={handlerPreviewPage}>
                        <img src={arrowLeft} className='moveback__icon' alt="icon of arrow at left" />
                        <p className='moveback__formula'>Torna alla pagina precedente</p>
                    </div>
                    <div className="content-lists">
                        <div className="content-halflist">
                            <div className="list" >
                                {artAB.map((item, index) => (
                                    <ul key={index}>
                                        <li className={index === 0 ? "primo-elemento" : "sidetab__navlink"}>
                                            <Link className="nav-link" to={item?.collegamento || '#'} 
                                                /*state={{scrollCurrent}} onClick={() => {handleScroll()}}*/>
                                                <span> ▶ </span>{item?.articolo_titolo || 'Item'}
                                            </Link>
                                        </li>
                                    </ul>
                                ))}
                            </div>
                            <div className="list" >
                                {artChoose.map((item, index) => (
                                    <ul key={index}>
                                        <li className={index === 0 ? "primo-elemento" : "sidetab__navlink"}>
                                            <Link className="nav-link" to={item?.collegamento || '#'}
                                                /*state={{scrollCurrent}} onClick={() => {handleScroll()}}*/>
                                                <span> ▶ </span>{item?.articolo_titolo || 'Item'}
                                            </Link>
                                        </li>
                                    </ul>
                                ))}
                            </div>
                            <div className="list" >
                                {artTaste.map((item, index) => (
                                    <ul key={index}>
                                        <li className={index === 0 ? "primo-elemento" : "sidetab__navlink"}>
                                            <Link className="nav-link" to={item?.collegamento || '#'}
                                                /*state={{scrollCurrent}} onClick={() => {handleScroll()}}*/>
                                                <span> ▶ </span>{item?.articolo_titolo || 'Item'}
                                            </Link>
                                        </li>
                                    </ul>
                                ))}
                            </div>   
                        </div>
                        <div className="content-halflist">
                            <div className="list">
                                {provinceData.map((item, index) => (
                                    <ul key={item.id_accord}>
                                        <li className={index === 0 ? "primo-elemento" : "sidetab__navlink"}>
                                            <Link className="nav-link" to="/provincedellabruzzo" state={{index: item.id_accord}}
                                                /*state={{scrollCurrent}} onClick={() => {handleScroll()}}*/>
                                                <span> ▶ </span>{item?.name || 'Item'}
                                            </Link>
                                        </li>
                                    </ul>
                                ))}
                            </div>    
                            <div className="list" >
                                {artTipo.map((item, index) => (
                                    <ul key={index}>
                                        <li className={index === 0 ? "primo-elemento" : "sidetab__navlink"}>
                                            <Link className="nav-link" to={item?.collegamento || '#'}
                                                /*state={{scrollCurrent}} onClick={() => {handleScroll()}}*/>
                                                <span> ▶ </span>{item?.articolo_titolo || 'Item'}
                                            </Link>
                                        </li>
                                    </ul>
                                ))}
                            </div>
                            <div className="list" >
                                {artViti.map((item, index) => (
                                    <ul key={index}>
                                        <li className={index === 0 ? "primo-elemento" : "sidetab__navlink"}>
                                            <Link className="nav-link" to={item?.collegamento || '#'}
                                                /*state={{scrollCurrent}} onClick={() => {handleScroll()}}*/>
                                                <span> ▶ </span>{item?.articolo_titolo || 'Item'}
                                            </Link>
                                        </li>
                                    </ul>
                                ))}
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default SideTab;
